import { schema } from 'normalizr';

const categorySchema = new schema.Entity('categories', {}, {
  idAttribute: category => category.id
});

const courseSchema = new schema.Entity('courses', {}, {
  idAttribute: course => course.id
});

const eventSchema = new schema.Entity('events', {}, {
  idAttribute: event => event.id
});

const proSchema = new schema.Entity('pros', {}, {
  idAttribute: pro => pro.id
});

const bookingSchema = new schema.Entity('bookings', {}, {
  idAttribute: booking => booking.id
});

const paymentSchema = new schema.Entity('payments', {}, {
  idAttribute: payment => payment.order_number
});

const searchResultSchema = new schema.Entity('events', {
  results: eventSchema
});


// Schemas for API responses.
export const Schemas = {
  BOOKING: bookingSchema,
  PAYMENT: paymentSchema,
  COURSE: courseSchema,
  COURSE_ARRAY: [courseSchema],
  CATEGORY: categorySchema,
  CATEGORY_ARRAY: [categorySchema],
  EVENT: eventSchema,
  EVENT_ARRAY: [eventSchema],
  PRO: proSchema,
  PRO_ARRAY: [proSchema],
  SEARCH_RESULTS: [searchResultSchema],
}



// WEBPACK FOOTER //
// ./src/api/schema.js